<template>
  <v-row justify="center">
    <v-dialog v-model="dialogLogin" max-width="500" persistent>
        <div class="printed">
            <v-card outlined style="overflow-y: auto;">
                <div class="d-flex flex-row-reverse">
                    <v-btn icon @click="setDialogLogin(false)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-title class="pt-0">Login Customer</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-0">
                  <v-form @submit="validate" ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="email" 
                      label="E-mail / Username / Phone"
                      required
                      v-on:keyup.enter="validate"
                      prepend-icon="person"
                      type="text"
                    />

                    <v-text-field
                      v-model="password"
                      label="Password"
                      type="password"
                      required
                      v-on:keyup.enter="validate"
                      prepend-icon="lock"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn 
                      class="teal darken-4 white--text"
                      :disabled="!valid"
                      medium
                      @click="validate"
                  >
                      Login
                  </v-btn>
              </v-card-actions>
            </v-card>
        </div>
    </v-dialog>
    <v-snackbar style="z-index: 9999"
        :top='true'
        v-model='snackbar.visible'
        :color='snackbar.color'
        :timeout='snackbar.timeout'
        :multi-line='snackbar.multiline'
    >{{snackbar.text}}</v-snackbar>

    <v-overlay :value="overlay" style="z-index: 9999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find } from "lodash";
import { QRCanvas } from 'qrcanvas-vue';
import moment from 'moment';
export default {
  name: "DialogLogin",
  components: {
      QRCanvas,
  },
  data() {
    return {
      valid: true,
      password: "",
      email: "",
      overlay: false
    };
  },
  computed: {
      ...mapState({
          dialogLogin: state => state.pesanan.dialogLogin,
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      showLoading: "showLoading",
      closeLoading: "closeLoading",
      setDialogLogin: "pesanan/SET_DIALOG_LOGIN",
      setCustomer: "pesanan/SET_CUSTOMER",
    }),
    ...mapActions({
      logInCustomer: "auth/logInCustomer",
    }),
    async initialize(){
    },
    async validate() {
      if (this.$refs.form.validate()) {
        const payload = {
            email: this.email,
            password: this.password
        }
        try {
            this.overlay = true
            const response = await this.logInCustomer(payload);
            if (!response.data.success) {
                this.showSnackbar({ text: 'Login gagal, silahkan coba lagi...', color: 'red', timeout: 1500 })
            } else {
                this.showSnackbar({ text: 'Login berhasil...', color: 'green', timeout: 1500 })
                this.setCustomer(response.data.attributes.user)
                window.localStorage.setItem('dataCustomer', JSON.stringify(response.data.attributes.user));
                this.password= ""
                this.email= ""
                this.setDialogLogin(false)
                // console.log('response', response)
                // window.localStorage.setItem('listPesanan', JSON.stringify([]));
                // window.localStorage.setItem('validatorOrder', true);
                // window.localStorage.setItem('numberOfList', this.numberOfList);
                // if(window.localStorage.getItem('user_role') == 'stockiest'){
                //   this.$router.push("/orders");
                // }else{
                  // this.$router.push("/dashboard");
                // }
            }
            this.overlay = false
        } catch (err) {
          console.log(err);
        }
      }
    },
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>